import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton, Tooltip } from '@dixa/lib-shared-habla';
import { client as elevioClient } from 'elevio';
import { useMemo } from 'react';
import { articles } from 'utils/elevio';
export const AnalyticsDocumentationButton = ({ type, dashboard, articleId, }) => {
    const elevioArticleId = useMemo(() => {
        var _a;
        switch (type) {
            case 'dashboard':
                return (_a = articles.analytics.dashboards[dashboard.slug]) !== null && _a !== void 0 ? _a : '';
            case 'article':
            default:
                return articleId;
        }
    }, [articleId, dashboard === null || dashboard === void 0 ? void 0 : dashboard.slug, type]);
    return (_jsx(Tooltip, Object.assign({ content: "Help and documentation", dark: true }, { children: _jsx(IconButton, { icon: "question", variant: "tertiary", onClick: () => elevioClient.openArticle(elevioArticleId) }) })));
};
